// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__hYFKT","spinner":"styles_spinner__tT4jp","disabled":"styles_disabled__eifgi"};